import { Kinds, KindsEnum } from 'ha/constants/Room';
import buildParams from 'ha/utils/buildParams';
// eslint-disable-next-line import/no-cycle
import { formatDate } from 'ha/helpers/hadate';

const getEnumsByValues = (values, types, typesEnum) =>
  Object.entries(types)
    .filter(pair => values.includes(pair[1]))
    .map(([type]) => typesEnum[type])
    .join(',');

export default function buildSearchQuery(filters = {}) {
  const query = {};

  const {
    priceMin,
    priceMax,
    startDate,
    endDate,
    listingKinds = [],
    currency,
    userId,
  } = filters;

  if (priceMin) {
    query.priceMin = priceMin;
  }

  if (priceMax) {
    query.priceMax = priceMax;
  }

  if (currency) {
    query.currency = currency;
  }

  if (userId) {
    query.userId = userId;
  }

  if (startDate) {
    query.startDate = formatDate(undefined, 'YYYY-MM-DD', startDate);
  }

  if (endDate) {
    query.endDate = formatDate(undefined, 'YYYY-MM-DD', endDate);
  }

  if (listingKinds.length > 0) {
    query.kinds = getEnumsByValues(listingKinds, Kinds, KindsEnum);
  }

  return buildParams(query);
}
